import { CmsMeta } from '../cmsMeta';
import './CmsSpacer.css';

type CmsSpacerParams = {
	padding: 8 | 16 | 24 | 32 | 40 | 48 | 56 | 64;
};

export const CmsSpacer = ({ padding }: CmsSpacerParams): JSX.Element => {
	return <cms-spacer style={{ padding: padding + 'px' }}></cms-spacer>;
};

export const cmsMeta: CmsMeta = {
	description: 'Empty vertical space, in pixels. Use it to separate blocks that would otherwise sit too close.',
	example: ['CmsSpacer', { padding: 32 }],
};
